export default __webpack_public_path__ + "static/media/balance2.eb4b3347.svg";